export default __webpack_public_path__ + "static/media/upcomingCollectionIcon.cb8786cb.svg";